// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-4d199a4e]:root{--light_text_color:#666}.clutch-specifications[data-v-4d199a4e]{border-radius:4px;padding:10px 14px;background:#fdf7fa;border-left:6px solid #00913d}.clutch-specifications p[data-v-4d199a4e]{margin:5px 0 0;font-size:13px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
